export default __webpack_public_path__ + "static/media/54_desktop.5fc7fa60.jpg";